import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SideNav from '../components/SideNav'
import {
    changeAddRadarFormVisibility,
    sectorPageHandler,
    timerangePageHandler,
    changeAddPhenomenaVisibility,
    toggleEditMenuVisiblity
} from '../actions/radarSettings'
import { changeSignalListVisibility } from '../actions/signals'
import {
    deleteRadar,
    cloneRadar,
    generatePowerpoint
} from '../actions/radarData'
import { changeRadarSharing } from '../actions/radarSettings'
import { isCollaborationToolsAllowed } from '../selectors'
import { PUBLIC_URL } from '../env'
import { isPublicSharedLinkEnabled as  isPublicSharedLinkEnabled_selector} from '../selectors/index';

export default connect(
    (state, props) => {
        const {
            radarSettings: {
                signalToolEnabled,
                addRadarFormOpen,
                editMenuOpen,
                editPhenomenaVisible,
                addPhenomenaVisible,
                editSectorsPageOpen,
                id,
                group,
                groups,
                canDeleteRadar,
                canEditRadar,
                isVisitor,
                canShareRadar,
                editTimeRangesPageOpen,
                radarName,
                userInfo
            },
            signals: {
                signalListVisible
            }
        } = state

        const collaborationToolsAllowed = group && groups ?
            isCollaborationToolsAllowed(state)(group.id) : false
        const isPublicSharedLinkEnabled = isPublicSharedLinkEnabled_selector(state)
        return {
            signalToolEnabled,
            addRadarFormOpen,
            editPhenomenaVisible,
            signalListVisible,
            addPhenomenaVisible,
            editSectorsPageOpen,
            id,
            groupId: group.id,
            collaborationToolsAllowed,
            isPublicSharedLinkEnabled,
            canDeleteRadar,
            isVisitor,
            canShareRadar,
            canEditRadar,
            getReturnUrl: () => props.returnUri || PUBLIC_URL || '/',
            editMenuOpen,
            editTimeRangesPageOpen,
            radarName,
            userInfo
        }
    },
    dispatch => bindActionCreators({
        changeSignalListVisibility,
        deleteRadar,
        sectorPageHandler,
        changeAddRadarFormVisibility,
        timerangePageHandler,
        changeAddPhenomenaVisibility,
        cloneRadar,
        toggleEditMenuVisiblity,
        generatePowerpoint,
        changeRadarSharing
    }, dispatch)
)(SideNav)
